import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LoadingScreen } from '../screens/LoadingScreen';
import { SkipLink } from '../components/SkipLink';
import { MatrixCreateDraftProvider } from '../contexts/MatrixCreateDraftContext';

// Top-level layout route. Renders the app tree only when the user is
// authenticated; otherwise redirects to /login with a `?next=` param that
// preserves the intended destination so post-login we can land back here.
//
// Keeps auth gating in one place — no screen should need its own check.
export function AuthGate() {
  const { loading, userEmail } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingScreen />;

  if (!userEmail) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return (
    <>
      {/* First focusable element in the authed tree — see SkipLink.tsx. */}
      <SkipLink />
      <MatrixCreateDraftProvider key={userEmail.toLowerCase()}><Outlet /></MatrixCreateDraftProvider>
    </>
  );
}
